import SimpleFormGroup from './SimpleFormGroup';

export default SimpleFormGroup;
